import api from "../BrandOnBoarding/api";

function buildParams(filters = {}) {
  const params = new URLSearchParams();
  if (filters.from_date) params.set("from_date", filters.from_date);
  if (filters.to_date) params.set("to_date", filters.to_date);
  if (filters.customer_id?.length) params.set("customer_id", filters.customer_id.join(","));
  if (filters.user_id?.length) params.set("user_id", filters.user_id.join(","));
  if (filters.request_type?.length) params.set("request_type", filters.request_type.join(","));
  if (filters.status?.length) params.set("status", filters.status.join(","));
  if (filters.page) params.set("page", filters.page);
  if (filters.limit) params.set("limit", filters.limit);
  return params.toString();
}

export async function fetchModuleUsageList(filters = {}) {
  const qs = buildParams(filters);
  const res = await api.get(`/admin/module-usage${qs ? `?${qs}` : ""}`);
  return res.data;
}

export async function fetchModuleUsageStats() {
  const res = await api.get("/admin/module-usage/stats");
  return res.data;
}

export async function fetchModuleUsageDetail(transactionId) {
  const res = await api.get(`/admin/module-usage/${transactionId}`);
  return res.data;
}

export async function fetchModuleUsageFilterOptions() {
  const res = await api.get("/admin/module-usage/filters/options");
  return res.data;
}

export async function fetchNotificationSettings() {
  const res = await api.get("/admin/notification-settings");
  return res.data;
}

export async function updateNotificationSetting(customerId, enabled) {
  const res = await api.put(`/admin/notification-settings/${customerId}`, { enabled });
  return res.data;
}
